import React from 'react';
import { JobProfileProvider } from './JobProfile.context';
import { Header } from './components/Header/Header';
import { useJobProfile } from './JobProfile.hooks';
import File from 'App/assets/img/job-profile-blue.svg?url';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import { ProfileFileMenu } from './components/ProfileFileMenu/ProfileFileMenu';

export const JobProfile = () => {
	const { targetRef, onAction, ComponentViewer } = useJobProfile();

	useAnalyticsOpenScreen({
		context: 'job-profile',
		trackName: 'Open Job Profiles',
	});

	return (
		<div ref={targetRef}>
			<JobProfileProvider>
				<Header
					image={File}
					title="Perfiles de puesto"
					slotHeader={<ProfileFileMenu onClick={onAction} />}
				/>

				<ComponentViewer />
			</JobProfileProvider>
		</div>
	);
};
